import { render, staticRenderFns } from "./CommoditiesLayout.vue?vue&type=template&id=cde9877e&scoped=true&"
import script from "./CommoditiesLayout.vue?vue&type=script&lang=js&"
export * from "./CommoditiesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde9877e",
  null
  
)

export default component.exports